import MicroModal from 'micromodal';
import { redirect } from '../helpers/url';
/**
 * Obsługa formularza logowania
 */
const handleLoginForm = (form) => {
    if (form === null) {
        return;
    }
    const login = (form) => {
        const formData = new FormData(form);
        return fetch('/auth/login', {
            method: 'POST',
            credentials: 'include',
            cache: 'no-cache',
            body: formData,
        }).then((response) => {
            if (response.ok === false) {
                throw new Error('Unknown failure');
            }
            return response.json();
        });
    };
    // Obsługa walidacji
    const validatedFields = {
        login: form.querySelector('input[type=email]'),
        password: form.querySelector('input[type=password]'),
    };
    const clearValidationErrors = (field) => {
        if (field === null) {
            return;
        }
        if (typeof field !== 'undefined') {
            if (field.nextElementSibling !== null) {
                field.nextElementSibling.textContent = '';
            }
            if (field.parentElement !== null) {
                field.parentElement.classList.remove('error');
            }
        }
        else {
            Object.keys(validatedFields).forEach((key) => {
                clearValidationErrors(validatedFields[key]);
            });
        }
    };
    Object.keys(validatedFields).forEach((field) => {
        const input = validatedFields[field];
        if (input === null) {
            return;
        }
        input.addEventListener('keyup', () => {
            clearValidationErrors(input);
        });
    });
    // Zapis formularza
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        const button = form.querySelector('button');
        if (button !== null) {
            button.setAttribute('disabled', 'disabled');
        }
        // Wyzerowanie błędów z API
        clearValidationErrors();
        login(form)
            .then((response) => {
            if (response.success) {
                // Poprawna autoryzacja
                const requestFrom = form.getAttribute('data-requestfrom');
                const returnUrl = form.getAttribute('data-returnurl');
                if (requestFrom == 'cart') {
                    redirect('/cart/delivery');
                }
                else if (returnUrl != '' && returnUrl !== null) {
                    redirect(returnUrl);
                }
                else if (typeof response.redirect_to === 'string') {
                    redirect(response.redirect_to);
                }
                else {
                    redirect('/customer');
                }
            }
            else {
                // Błąd autoryzacji
                if (typeof response.errors !== 'undefined' && response.errors.needsPasswordChange) {
                    // Konto wymaga resetu hasła
                    const formData = new FormData();
                    formData.set('email', form.querySelector('input[type=email]').value);
                    return fetch('/customer/passreminder', {
                        method: 'POST',
                        credentials: 'include',
                        cache: 'no-cache',
                        body: formData,
                    })
                        .then((response) => {
                        if (response.ok === false) {
                            throw new Error('Unknown failure');
                        }
                        return response.json();
                    })
                        .then((response) => {
                        if (response.success) {
                            redirect('/auth/resetpassinfo');
                        }
                    })
                        .catch((err) => {
                        // Błąd komunikacji
                        console.error(err);
                    });
                }
                for (const field in response.errors) {
                    const msg = response.errors[field];
                    const fieldInDom = validatedFields[field] ?? null;
                    if (fieldInDom !== null) {
                        if (fieldInDom.nextElementSibling !== null) {
                            fieldInDom.nextElementSibling.textContent = msg;
                        }
                        if (fieldInDom.parentElement !== null) {
                            fieldInDom.parentElement.classList.add('error');
                        }
                    }
                }
                if (button !== null) {
                    button.removeAttribute('disabled');
                }
            }
        })
            .catch((err) => {
            // Błąd komunikacji
            console.error(err);
            if (button !== null) {
                button.removeAttribute('disabled');
            }
        });
    });
};
/**
 * Obsługa formularza resetowania hasła
 */
const handleResetPassForm = (form) => {
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        form.querySelectorAll('.form-group.error').forEach((el) => el.classList.remove('error'));
        form.querySelectorAll('.form-group .status').forEach((el) => {
            el.textContent = '';
        });
        const button = form.querySelector('button');
        if (button !== null) {
            button.setAttribute('disabled', 'disabled');
        }
        const formData = new FormData(form);
        fetch('/customer/passreminder', {
            method: 'POST',
            credentials: 'include',
            cache: 'no-cache',
            body: formData,
        })
            .then((response) => {
            if (response.ok === false) {
                throw new Error('Unknown failure');
            }
            return response.json();
        })
            .then((response) => {
            if (response.success) {
                MicroModal.close('modal-reset-password');
                MicroModal.show('modal-reset-password-success', {
                    disableScroll: true,
                    onClose: (modal, activeElement, event) => {
                        // Zapobiegnięcie kliknięciu w element pod overlay w przypadku urządzeń mobilnych
                        if (event !== null) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    },
                });
            }
            else {
                console.error(response.errors);
                if (typeof response.errors.email !== 'undefined') {
                    const emailField = form.querySelector('input[name=email]');
                    if (emailField !== null) {
                        const emailGroup = emailField.parentElement;
                        if (emailGroup !== null) {
                            emailGroup.classList.add('error');
                            const status = emailGroup.querySelector('.status');
                            if (status !== null) {
                                status.textContent = response.errors.email;
                            }
                        }
                    }
                }
            }
            if (button !== null) {
                button.removeAttribute('disabled');
            }
        })
            .catch((err) => {
            // Błąd komunikacji
            console.error(err);
            if (button !== null) {
                button.removeAttribute('disabled');
            }
        });
    });
};
export default () => {
    // Obsługa formularza logowania
    const form = document.querySelector('#login-page__form');
    if (form === null) {
        return;
    }
    handleLoginForm(form);
    // Aktywacja formularza przypominania hasła
    document.querySelectorAll('.js-show-reminder-form').forEach((btn) => {
        btn.addEventListener('click', () => {
            MicroModal.show('modal-reset-password', {
                disableScroll: true,
                onClose: (modal, activeElement, event) => {
                    // Zapobiegnięcie kliknięciu w element pod overlay w przypadku urządzeń mobilnych
                    if (event !== null) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                },
            });
        });
    });
    // Obsługa formularza przypominania hasła
    document.querySelectorAll('.reset-pass-form').forEach((form) => handleResetPassForm(form));
    // Obsługa autoryzacji social auth
    document.querySelectorAll('.social-auth-button').forEach((btn) => {
        btn.addEventListener('signed', (e) => {
            if (typeof e.detail.type !== 'string') {
                return;
            }
            const requestFrom = form.getAttribute('data-requestfrom');
            const returnUrl = form.getAttribute('data-returnurl');
            if (e.detail.type === 'logged') {
                // Pomyślne zalogowanie na istniejące konto e-commerce
                if (requestFrom == 'cart') {
                    // W trakcie procesu zakupowego, przekierowujemy dalej
                    redirect('/cart/delivery');
                }
                else if (returnUrl != '' && returnUrl !== null) {
                    // W formularzu istnieje wymuszony URL powrotu
                    redirect(returnUrl);
                }
                else if (typeof e.detail.redirectTo === 'string') {
                    // Backend zwrócił URL do przekierowania (akcje marketingowe etc)
                    redirect(e.detail.redirectTo);
                }
                else {
                    // Brak informacji o celu przekierowania - przekierowujemy do konta klienta (prawdopodobnie to
                    // ta sekcja spowodowała przekierowanie na formularz logowania)
                    redirect('/customer/index/loggedin/1');
                }
            }
            else if (e.detail.type == 'account_created') {
                // Konto nie istnieje w e-commerce, wymaga rejestracji (przekierowanie)
                const data = {
                    source: e.detail.source,
                    firstName: e.detail.firstName,
                };
                if (typeof e.detail.email !== 'undefined' && e.detail.email) {
                    data.email = e.detail.email;
                }
                if (typeof e.detail.lastName !== 'undefined' && e.detail.lastName) {
                    data.lastName = e.detail.lastName;
                }
                if (typeof e.detail.phoneNumber !== 'undefined' && e.detail.phoneNumber) {
                    data.phoneNumber = e.detail.phoneNumber;
                }
                // Przekierowanie na /customer/register/from/cart, jeżeli ktoś był w koszyku (po rejestracji zostanie
                // przekierowany do dalszych kroków)
                let fromUri = '';
                if (requestFrom) {
                    fromUri = '/from/' + encodeURIComponent(requestFrom);
                }
                redirect('/customer/register' + fromUri + '?data=' + btoa(encodeURIComponent(escape(JSON.stringify(data)))));
            }
        });
    });
};
